import Transitions from 'app/ui/Transitions';
import DeviceController from 'app/controller/DeviceController';

class StateController {
  constructor({ game, transitionType = DeviceController.TRANSITIONS_FULL }) {
    this.game = game;

    this.transitionType = transitionType;
    this.transitionToState = false;
    this.transitionToParams = false;

    this.onTransitionComplete = new Phaser.Signal();
    this.isStateTransition = false;
  }

  clearCurrentState() {
    this.game.state.clearCurrentState();
  }

  switchStates() {
    this.game.state.start(this.transitionToState, ...this.transitionToParams);
    this.game.state.onStateChange.addOnce(this.handleStateChanged, this);
  }

  handleStateChanged() {
    this.game.camera.x = 0;
    this.game.camera.y = 0;
    // this.game.time.events.add(300, this.transitionOut, this).autoDestroy = true;
    this.game.hud.show(); // show hud when covered with transition
  }

  transitionOut() {
    this.transitions.transitionEnd();
  }

  onTransitionInComplete() {
    this.switchStates();
  }

  onTransitionOutComplete() {
    this.onTransitionComplete.dispatch();
    this.transitions.destroy();
    this.transitions = null;
    this.isStateTransition = false;
  }

  startState({ nextState, nextStateParams }) {
    // if (this.isStateTransition) {
    //   console.log('stuck in transition');
    //   return;
    //

    this.transitionToState = nextState;
    this.transitionToParams = nextStateParams;
    this.isStateTransition = true;
    this.switchStates();
    // let type = Transitions.POLY_MASK;
    // let enabled = true;
    // switch (this.transitionType) {
    //   case DeviceController.TRANSITIONS_FULL:
    //     type = Transitions.POLY_MASK;
    //     break;
    //   case DeviceController.TRANSITIONS_LOWFI:
    //     type = Transitions.LOW_FI;
    //     break;
    //   case DeviceController.TRANSITIONS_NONE:
    //     type = '';
    //     enabled = false;
    //     break;
    // }

    // this.transitions = new Transitions({ game: this.game, type, enabled });
    // this.transitions.onTransitionInComplete.add(this.onTransitionInComplete, this);
    // this.transitions.onTransitionOutComplete.add(this.onTransitionOutComplete, this);
    // this.transitions.startTransition({ type });
  }
}

export default StateController;
